module.exports = __webpack_public_path__ + "static/img/gongan.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/byl/footer/images/gongan.png
// module id = zkel
// module chunks = 1